export function filterFramesByLocation(frames, locationHref) {
  const result = [];
  for (let index = 0; index < frames.length; index++) {
    const frame = frames[index];
    try {
      if (frame.location.origin === locationHref) {
        result.push(frame);
      }
    } catch (e) {} // eslint-disable-line no-empty
  }

  return result;
}

export function filterFramesByFieldId(fieldId = '', frames) {
  frames = frames || filterFramesByLocation(window.parent.frames, window.location.origin);

  return frames.filter((frame) => {
    try {
      const configuration = frame.globalConfig;
      return configuration.fieldId === fieldId;
    } catch (e) {
      return false;
    }
  });
}

export function filterFramesByFieldType(type = '', frames) {
  frames = frames || filterFramesByLocation(window.parent.frames, window.location.origin);
  return frames.filter((frame) => {
    try {
      const configuration = frame.globalConfig;
      return configuration.type === type;
    } catch (e) {
      return false;
    }
  });
}

export function filterFramesByFormId(formId, frames) {
  frames = frames || filterFramesByLocation(window.parent.frames, window.location.origin);

  return frames.filter((frame) => {
    try {
      return frame && frame.globalConfig.formId === formId;
    } catch (e) {
      return false;
    }
  });
}
